// 菲律宾
export const common = {
  cancel:"Itigil",
  confirm:"Patvirtin",
  country:"Country"
};
// 订单列表页面
export const orderList = {
  title:"Stock label",
};

// 查询页面
export const cardLoop = {
  cardTitle:"ICCID numero ng SIM card",
  cardDesc:"Ipasok ang ICCID na numero ng SIM card sa input box.",
  query:"Paghahanap",
  title:"Plataporma ng IOT SIM card",
};

// 详情页面
export const cardInfo = {
  title:"card information",
  msisdn:"MSISDN：",  
  iccid:"ICCID：",
  expiration:"Pagtatapos：",//过期时间
  status:'estado',
  refresh:"refresh",//刷新
  residualFlow:"Stock label",
  totalFlow:"Kabilang",
  used:"Ginamit",
  lists:["Gamit","Hindi ginagamit","Tapos"],//1 生效中 2 未生效 3.已失效
  validity:"validity",
  skuUsed:"Ginamit",
  skuTotal:"Kabilang",
  recharge:"keyboard label",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"Stock label",
  buyPlan:"Buy Plan",
  select:"Piliin ang plano",//未选套餐的提示
  orderList:"Stock label",
  userAgreement:"User Agreement",
  price:"Price ng Package",
  flowCount:"Total flow",
  validityTime:"Effective date",
  switchCountryName:"Gamitin na lugar",
  productDesc:"Paglalarawan ng Package",
  productDescText:"Advance charge",
  paymentMethod:"Payment method",
  checkUserAgreementMsg:"Mangyaring suriin ang user agreement",
  payErrorMsg:"Ang natatanggap na account ay hindi suportahan ng RMB payment",
  payBtnText:"Bilin Sa",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"Mga resulta ng pagbabayad",
  Details:"Mga detalye",//返回详情
}


export const country = {
  America:'Amerika',
  HongKong:'Hong Kong',
  Thailand:'Thailand',
  Philippines:'Pilipinas',
  Macao:'Macao'
}


// 位置标签
export const placeTitle = "Country";

// 国家名称
export const China = "China"
export const America = "America"
export const HongKong = "Hong Kong"






